<nb-select outline placeholder="Select Rider" shape="rectangle" status="info">
	<nb-option (selectionChange)="sendRiderId.emit(rider.id)" *ngFor="let rider of riders"
			   [value]="rider.id">{{rider.name}}</nb-option>
</nb-select>
